import {
  CostingProfileDetailsTab,
  PricingProfileDetailsTab,
  PricingProfilePricingType,
} from 'pricing/enums';

export const costingProfileListPath = () => '/costing-profile/list';
export const costingProfileDetailsPath = (
  id: number | string = ':id',
  tab?: CostingProfileDetailsTab
) => {
  const basePath = `/costing-profile/${id}`;

  return tab ? `${basePath}?tab=${tab}` : basePath;
};

export const pricingProfileListPath = () => '/pricing-profile/list';
export const pricingProfileDetailsPath = (
  id: number | string = ':id',
  tab?: PricingProfileDetailsTab
) => {
  const basePath = `/pricing-profile/${id}`;

  return tab ? `${basePath}?tab=${tab}` : basePath;
};

export const getPricingProfilePath = (type: PricingProfilePricingType, id: number) => {
  switch (type) {
    case PricingProfilePricingType.COSTING:
      return costingProfileDetailsPath(id);
    case PricingProfilePricingType.PRICING:
      return pricingProfileDetailsPath(id);
  }
};
